import { SearchResult } from 'functions/src/types/firestore/Search';
import { Status } from 'src/components/Status';
import { AvatarNext } from 'src/components/AvatarNext';
import { SearchResultBase } from './SearchResultBase';

export type ProfileSearchResultProps = SearchResult & { category: 'profile' };

export const ProfileSearchResult = ({
  profile,
  title,
  description,
  objectID,
}: ProfileSearchResultProps) => {
  const profileUrl = `/profile/${objectID}`;

  return (
    <SearchResultBase
      href={profileUrl}
      image={
        <Status
          kind={'Badge'}
          statusEnum={profile.onlineStatus}
          sx={{
            '.MuiBadge-badge': {
              width: '12px',
              height: '12px',
              borderRadius: 5,
            },
          }}
        >
          <AvatarNext src={profile.imgUrl} sx={{ width: 90, height: 90 }} />
        </Status>
      }
      header={title}
      description={description}
      category="Profile"
    />
  );
};
